import { useLayoutEffect } from "react";

const SCROLL_EDGE_EPSILON = 2;

/**
 * Toggles scroll-edge classes on a horizontal scroll container so CSS can show
 * fade hints when more content is available off-screen.
 */
const useHorizontalScrollAffordance = (scrollRef, deps = []) => {
  useLayoutEffect(() => {
    const el = scrollRef.current;
    if (!el) return undefined;

    const update = () => {
      const canScroll = el.scrollWidth > el.clientWidth + SCROLL_EDGE_EPSILON;
      const atStart = el.scrollLeft <= SCROLL_EDGE_EPSILON;
      const atEnd =
        el.scrollLeft + el.clientWidth >= el.scrollWidth - SCROLL_EDGE_EPSILON;

      el.classList.toggle("patient-header-scroll--can-scroll", canScroll);
      el.classList.toggle("patient-header-scroll--start", atStart);
      el.classList.toggle("patient-header-scroll--end", atEnd);
    };

    update();
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(update);
      ro.observe(el);
      if (el.firstElementChild) {
        ro.observe(el.firstElementChild);
      }
    }

    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      ro?.disconnect();
      el.classList.remove(
        "patient-header-scroll--can-scroll",
        "patient-header-scroll--start",
        "patient-header-scroll--end"
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useHorizontalScrollAffordance;
